import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { withNamespaces } from 'react-i18next';

const DeleteButton = ({t, text, loading, onClick}) => (
    <button type="submit" className="btn btn-danger" disabled={loading} onClick={onClick}>
        {loading && <FontAwesomeIcon icon={faSpinner} pulse={true} />}
        &nbsp;
        {t(text)}
    </button>
);

DeleteButton.propTypes = {
    text: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
};

DeleteButton.defaultProps = {
    text: 'COMMON.DELETE',
};

export default withNamespaces()(DeleteButton);



// WEBPACK FOOTER //
// ./src/components/form/delete-button.js